import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Store } from "@ngxs/store";

import { PermitPaths } from "../../../permit-paths";
import { PreparedPermitListItem } from "../../models/prepared-permit-list-item.model";
import { PermitListActions } from "../../states/permit-list.actions";

@Component({
    selector: "pmt-prepared-permit-list-item",
    templateUrl: "./prepared-permit-list-item.component.html",
    styleUrls: ["./prepared-permit-list-item.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreparedPermitListItemComponent {
    @Input() public item!: PreparedPermitListItem;

    @Input() public hotWorkPermitId?: number;

    @Input() public retrieveFlammableAtexPermitMode = false;

    public permitPaths = PermitPaths;

    constructor(private store: Store) { }

    public onClick(): void {
        if (this.retrieveFlammableAtexPermitMode && this.hotWorkPermitId && this.hotWorkPermitId > 0) {
            this.store.dispatch(
                new PermitListActions.ConnectStandaloneFlammableAtexPermit(this.hotWorkPermitId, this.item.id),
            );
            return;
        }

        this.store.dispatch(new PermitListActions.ClaimPreparedPermit(this.item.id));
    }

    public fullPermitName(item: PreparedPermitListItem): string {
        if (item.workplaceContainer == null)
            return item.workplace;
        else
            return item.workplace?.length > 0 ? item.workplaceContainer + " - " + item.workplace : item.workplaceContainer;
    }
}
